/* eslint-disable react/jsx-props-no-spreading */

import React from 'react'
import { useSelector } from 'react-redux'
import { Route, Redirect, RouteProps } from 'react-router-dom'

import { selectIsAuthenticated } from '../../store/auth.selectors'

import { selectFeatureFlag, Flags } from '~/featureFlags'
import { CustomCircularProgress } from '~/ui/components'

export default function AuthenticatedRoute({ children, ...rest }: RouteProps) {
  const { isAuthenticated, loading } = useSelector(selectIsAuthenticated)
  const isLoginActiveFlag = useSelector(selectFeatureFlag(Flags.isLoginActive))

  if (!isLoginActiveFlag) {
    return <Route {...rest} render={() => children} />
  }

  if (loading) {
    return <CustomCircularProgress />
  }

  return (
    <Route
      {...rest}
      render={({ location }) =>
        isAuthenticated ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: location },
            }}
          />
        )
      }
    />
  )
}
